<template>
  <div>
    <!-- Filtros -->
    <div class="row mb-4">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h5 class="mb-0">
              <i class="fas fa-filter mr-2"></i>
              Filtros
            </h5>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-3">
                <label>Período Inicial</label>
                <input
                  type="date"
                  class="form-control"
                  v-model="filtros.startDate"
                  @change="aplicarFiltros"
                />
              </div>
              <div class="col-md-3">
                <label>Período Final</label>
                <input
                  type="date"
                  class="form-control"
                  v-model="filtros.endDate"
                  @change="aplicarFiltros"
                />
              </div>
              <div class="col-md-3">
                <label>Pipeline</label>
                <select
                  class="form-control"
                  v-model="filtros.pipelineId"
                  @change="aplicarFiltros"
                >
                  <option value="">Todas as pipelines</option>
                  <option
                    v-for="p in pipelines"
                    :key="p.id"
                    :value="p.id"
                  >
                    {{ p.value }}
                  </option>
                </select>
              </div>
              <div class="col-md-3">
                <label>Ferramenta</label>
                <select
                  class="form-control"
                  v-model="filtros.toolName"
                  @change="aplicarFiltros"
                >
                  <option value="">Todas as ferramentas</option>
                  <option
                    v-for="tool in toolNames"
                    :key="tool"
                    :value="tool"
                  >
                    {{ formatToolName(tool) }}
                  </option>
                </select>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-md-3">
                <label>Status</label>
                <select
                  class="form-control"
                  v-model="filtros.status"
                  @change="aplicarFiltros"
                >
                  <option value="">Todos</option>
                  <option value="success">Sucesso</option>
                  <option value="failed">Falha</option>
                </select>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-md-3">
                <label>Oportunidade (ID)</label>
                <input
                  type="number"
                  class="form-control"
                  v-model="filtros.oportunidadeId"
                  @change="aplicarFiltros"
                  placeholder="Digite o ID da oportunidade"
                />
              </div>
              <div class="col-md-6 d-flex align-items-end">
                <button
                  class="btn btn-primary mr-2"
                  @click="aplicarFiltros"
                >
                  <i class="fas fa-search mr-1"></i>
                  Aplicar Filtros
                </button>
                <button
                  class="btn btn-secondary"
                  @click="limparFiltros"
                >
                  <i class="fas fa-times mr-1"></i>
                  Limpar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Métricas Gerais -->
    <div class="row mb-4" v-if="metricas.metricas_gerais">
      <div class="col-lg-2 col-md-4 col-sm-6 mb-3">
        <div class="card metric-card border-left-primary">
          <div class="card-body">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div class="text-xs font-weight-bold text-primary text-uppercase mb-1">
                  Total Execuções
                </div>
                <div class="h5 mb-0 font-weight-bold text-gray-800">
                  {{ metricas.metricas_gerais.total_execucoes.toLocaleString() }}
                </div>
              </div>
              <div class="col-auto">
                <i class="fas fa-play-circle fa-2x text-primary"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-2 col-md-4 col-sm-6 mb-3">
        <div class="card metric-card border-left-success">
          <div class="card-body">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div class="text-xs font-weight-bold text-success text-uppercase mb-1">
                  Sucessos
                </div>
                <div class="h5 mb-0 font-weight-bold text-gray-800">
                  {{ metricas.metricas_gerais.execucoes_sucesso.toLocaleString() }}
                </div>
              </div>
              <div class="col-auto">
                <i class="fas fa-check-circle fa-2x text-success"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-2 col-md-4 col-sm-6 mb-3">
        <div class="card metric-card border-left-danger">
          <div class="card-body">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div class="text-xs font-weight-bold text-danger text-uppercase mb-1">
                  Falhas
                </div>
                <div class="h5 mb-0 font-weight-bold text-gray-800">
                  {{ metricas.metricas_gerais.execucoes_falha.toLocaleString() }}
                </div>
              </div>
              <div class="col-auto">
                <i class="fas fa-times-circle fa-2x text-danger"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-2 col-md-4 col-sm-6 mb-3">
        <div class="card metric-card border-left-warning">
          <div class="card-body">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div class="text-xs font-weight-bold text-warning text-uppercase mb-1">
                  Taxa Sucesso
                </div>
                <div class="h5 mb-0 font-weight-bold text-gray-800">
                  {{ metricas.metricas_gerais.taxa_sucesso }}%
                </div>
              </div>
              <div class="col-auto">
                <i class="fas fa-percentage fa-2x text-warning"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-2 col-md-4 col-sm-6 mb-3">
        <div class="card metric-card border-left-info">
          <div class="card-body">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div class="text-xs font-weight-bold text-info text-uppercase mb-1">
                  Tempo Médio
                </div>
                <div class="h5 mb-0 font-weight-bold text-gray-800">
                  {{ formatarTempo(metricas.metricas_gerais.tempo_medio_execucao) }}
                </div>
              </div>
              <div class="col-auto">
                <i class="fas fa-clock fa-2x text-info"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-2 col-md-4 col-sm-6 mb-3">
        <div class="card metric-card border-left-secondary">
          <div class="card-body">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div class="text-xs font-weight-bold text-secondary text-uppercase mb-1">
                  Período
                </div>
                <div class="h6 mb-0 font-weight-bold text-gray-800">
                  {{ formatarPeriodo() }}
                </div>
              </div>
              <div class="col-auto">
                <i class="fas fa-calendar-alt fa-2x text-secondary"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Gráficos -->
    <div class="row mb-4">
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            <h5 class="mb-0">
              <i class="fas fa-chart-pie mr-2"></i>
              Execuções por Ferramenta
            </h5>
          </div>
          <div class="card-body">
            <simple-chart 
              :data="metricas.execucoes_por_ferramenta"
              label-field="tool_name"
              value-field="total"
              :colors="['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#FF9F40', '#C9CBCF']"
            />
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            <h5 class="mb-0">
              <i class="fas fa-chart-line mr-2"></i>
              Execuções por Dia
            </h5>
          </div>
          <div class="card-body">
            <simple-chart 
              :data="metricas.execucoes_por_dia"
              label-field="data"
              value-field="total"
              :colors="['#36A2EB']"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            <h5 class="mb-0">
              <i class="fas fa-chart-bar mr-2"></i>
              Execuções por Hora
            </h5>
          </div>
          <div class="card-body">
            <simple-chart 
              :data="metricas.execucoes_por_hora"
              label-field="hora"
              value-field="total"
              :colors="['#4BC0C0']"
            />
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            <h5 class="mb-0">
              <i class="fas fa-chart-pie mr-2"></i>
              Taxa de Sucesso por Ferramenta
            </h5>
          </div>
          <div class="card-body">
            <simple-chart 
              :data="metricas.taxa_sucesso_por_ferramenta"
              label-field="tool_name"
              value-field="taxa_sucesso"
              type="percentage"
              :colors="['#28a745', '#ffc107', '#dc3545']"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Tabela de Execuções -->
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h5 class="mb-0">
              <i class="fas fa-list mr-2"></i>
              Execuções Recentes
            </h5>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Ferramenta</th>
                    <th>Contexto</th>
                    <th>Status</th>
                    <th>Tempo</th>
                    <th>Treinamento</th>
                    <th>Pipeline</th>
                    <th>Data</th>
                    <th>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="execucao in execucoes.data" :key="execucao.id">
                    <td>{{ execucao.id }}</td>
                    <td>
                      <span class="badge badge-info">
                        {{ formatToolName(execucao.tool_name) }}
                      </span>
                    </td>
                    <td>
                      <span class="badge badge-secondary">
                        {{ execucao.execution_context_label }}
                      </span>
                    </td>
                    <td>
                      <span
                        class="badge"
                        :class="execucao.output_success ? 'badge-success' : 'badge-danger'"
                      >
                        {{ execucao.output_success ? 'Sucesso' : 'Falha' }}
                      </span>
                    </td>
                    <td>{{ execucao.execution_time_formatted }}</td>
                    <td>{{ execucao.inteligencia_artificial?.nome || 'N/A' }}</td>
                    <td>{{ nomePipeline(execucao.pipeline?.id) }}</td>
                    <td>{{ execucao.created_at }}</td>
                    <td>
                      <button
                        class="btn btn-sm btn-primary"
                        @click="verDetalhes(execucao.id)"
                      >
                        <i class="fas fa-eye"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Paginação -->
            <div class="d-flex justify-content-between align-items-center mt-3">
              <div>
                <span class="text-muted">
                  Mostrando {{ execucoes.from || 0 }} a {{ execucoes.to || 0 }} de {{ execucoes.total || 0 }} registros
                </span>
              </div>
              <nav>
                <ul class="pagination pagination-sm mb-0">
                  <li class="page-item" :class="{ disabled: !execucoes.prev_page_url }">
                    <a class="page-link" href="#" @click.prevent="carregarPagina(execucoes.current_page - 1)">
                      Anterior
                    </a>
                  </li>
                  <li
                    class="page-item"
                    v-for="page in paginasVisiveis"
                    :key="page"
                    :class="{ active: page === execucoes.current_page }"
                  >
                    <a class="page-link" href="#" @click.prevent="carregarPagina(page)">
                      {{ page }}
                    </a>
                  </li>
                  <li class="page-item" :class="{ disabled: !execucoes.next_page_url }">
                    <a class="page-link" href="#" @click.prevent="carregarPagina(execucoes.current_page + 1)">
                      Próxima
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de Detalhes -->
    <div
      class="modal fade"
      id="modalDetalhes"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalDetalhesLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalDetalhesLabel">
              Detalhes da Execução
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Fechar"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" v-if="detalhesExecucao">
            <div class="row">
              <div class="col-md-6">
                <h6>Informações Básicas</h6>
                <table class="table table-sm">
                  <tr>
                    <td><strong>ID:</strong></td>
                    <td>{{ detalhesExecucao.id }}</td>
                  </tr>
                  <tr>
                    <td><strong>Ferramenta:</strong></td>
                    <td>{{ formatToolName(detalhesExecucao.tool_name) }}</td>
                  </tr>
                  <tr>
                    <td><strong>Contexto:</strong></td>
                    <td>{{ detalhesExecucao.execution_context_label }}</td>
                  </tr>
                  <tr>
                    <td><strong>Status:</strong></td>
                    <td>
                      <span
                        class="badge"
                        :class="detalhesExecucao.output_success ? 'badge-success' : 'badge-danger'"
                      >
                        {{ detalhesExecucao.output_success ? 'Sucesso' : 'Falha' }}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td><strong>Tempo:</strong></td>
                    <td>{{ detalhesExecucao.execution_time_formatted }}</td>
                  </tr>
                  <tr>
                    <td><strong>Data:</strong></td>
                    <td>{{ detalhesExecucao.created_at }}</td>
                  </tr>
                </table>
              </div>
              <div class="col-md-6">
                <h6>Relacionamentos</h6>
                <table class="table table-sm">
                  <tr>
                    <td><strong>Treinamento:</strong></td>
                    <td>{{ detalhesExecucao.inteligencia_artificial?.nome || 'N/A' }}</td>
                  </tr>
                  <tr>
                    <td><strong>Pipeline:</strong></td>
                    <td>{{ nomePipeline(detalhesExecucao.pipeline?.id) }}</td>
                  </tr>
                  <tr>
                    <td><strong>Oportunidade:</strong></td>
                    <td>{{ detalhesExecucao.oportunidade?.nome || 'N/A' }}</td>
                  </tr>
                  <tr>
                    <td><strong>Protocolo:</strong></td>
                    <td>{{ detalhesExecucao.protocolo?.nome || 'N/A' }}</td>
                  </tr>
                </table>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-12">
                <h6>Mensagem de Entrada</h6>
                <div class="bg-light p-3 rounded">
                  <pre class="mb-0">{{ detalhesExecucao.input_message || 'N/A' }}</pre>
                </div>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-12">
                <h6>Parâmetros de Entrada</h6>
                <div class="bg-light p-3 rounded">
                  <pre class="mb-0">{{ detalhesExecucao.input_parameters_formatted }}</pre>
                </div>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-12">
                <h6>Mensagem de Saída</h6>
                <div class="bg-light p-3 rounded">
                  <pre class="mb-0">{{ detalhesExecucao.output_message || 'N/A' }}</pre>
                </div>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-12">
                <h6>Dados de Saída</h6>
                <div class="bg-light p-3 rounded">
                  <pre class="mb-0">{{ detalhesExecucao.output_data_formatted }}</pre>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              Fechar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'

export default {
  name: 'RelatoriosIA',
  data() {
    return {
      filtros: {
        startDate: '',
        endDate: '',
        pipelineId: '',
        toolName: '',
        status: '',
        oportunidadeId: ''
      },
      metricas: {},
      execucoes: {
        data: [],
        current_page: 1,
        last_page: 1,
        per_page: 20,
        total: 0,
        from: 0,
        to: 0,
        prev_page_url: null,
        next_page_url: null
      },
      pipelines: [],
      toolNames: [],
      detalhesExecucao: null,
    }
  },
  computed: {
    paginasVisiveis() {
      const current = this.execucoes.current_page
      const last = this.execucoes.last_page
      const delta = 2
      const range = []
      const rangeWithDots = []

      for (let i = Math.max(2, current - delta); i <= Math.min(last - 1, current + delta); i++) {
        range.push(i)
      }

      if (current - delta > 2) {
        rangeWithDots.push(1, '...')
      } else {
        rangeWithDots.push(1)
      }

      rangeWithDots.push(...range)

      if (current + delta < last - 1) {
        rangeWithDots.push('...', last)
      } else {
        rangeWithDots.push(last)
      }

      return rangeWithDots.filter((v, i, a) => a.indexOf(v) === i)
    }
  },
  mounted() {
    this.inicializarFiltros()
    this.carregarDadosIniciais()
  },
  methods: {
    inicializarFiltros() {
      const hoje = new Date()
      const trintaDiasAtras = new Date(hoje.getTime() - 30 * 24 * 60 * 60 * 1000)
      
      this.filtros.endDate = hoje.toISOString().split('T')[0]
      this.filtros.startDate = trintaDiasAtras.toISOString().split('T')[0]
    },
    async carregarDadosIniciais() {
      document.getElementById('overlayer-loading')?.classList.add('show-overlayer')
      
      try {
        await Promise.all([
          this.carregarPipelines(),
          this.carregarToolNames(),
          this.carregarMetricas(),
          this.carregarExecucoes()
        ])
      } finally {
        document.getElementById('overlayer-loading')?.classList.remove('show-overlayer')
      }
    },
    async carregarPipelines() {
      try {
        const response = await api.get(`/painel/oportunidades-pipelines`,
          {
            params: {
              data: 1
            }
          }
        );
        
        this.pipelines = response.data
      } catch (error) {
        console.error('Erro ao carregar pipelines:', error)
      }
    },
    async carregarToolNames() {
      try {
        const response = await api.get('/painel/ia/relatorios/tool-names', {
          params: { lojaId: window.lojaId }
        })
        this.toolNames = response.data
      } catch (error) {
        console.error('Erro ao carregar ferramentas:', error)
      }
    },
    async carregarMetricas() {
      try {
        const response = await api.get('/painel/ia/relatorios/metricas', {
          params: {
            lojaId: window.lojaId,
            ...this.getFiltrosFormatados()
          }
        })
        this.metricas = response.data
      } catch (error) {
        console.error('Erro ao carregar métricas:', error)
        window.showToastDanger?.('body', 'Erro ao carregar métricas')
      }
    },
    async carregarExecucoes(pagina = 1) {
      try {
        const response = await api.get('/painel/ia/relatorios/execucoes', {
          params: {
            lojaId: window.lojaId,
            page: pagina,
            perPage: 20,
            ...this.getFiltrosFormatados()
          }
        })
        this.execucoes = response.data.execucoes
      } catch (error) {
        console.error('Erro ao carregar execuções:', error)
        window.showToastDanger?.('body', 'Erro ao carregar execuções')
      }
    },
    async verDetalhes(id) {
      try {
        const response = await api.get(`/painel/ia/relatorios/execucao/${id}`)
        this.detalhesExecucao = response.data.execucao
        $('#modalDetalhes').modal('show')
      } catch (error) {
        console.error('Erro ao carregar detalhes:', error)
        window.showToastDanger?.('body', 'Erro ao carregar detalhes da execução')
      }
    },
    aplicarFiltros() {
      this.carregarMetricas()
      this.carregarExecucoes(1)
    },
    limparFiltros() {
      this.inicializarFiltros()
      this.filtros.pipelineId = ''
      this.filtros.toolName = ''
      this.filtros.status = ''
      this.filtros.oportunidadeId = ''
      this.aplicarFiltros()
    },
    carregarPagina(pagina) {
      if (pagina >= 1 && pagina <= this.execucoes.last_page) {
        this.carregarExecucoes(pagina)
      }
    },
    formatToolName(toolName) {
      if (!toolName) return 'N/A'
      return toolName
        .replace(/_/g, ' ')
        .replace(/\b\w/g, l => l.toUpperCase())
    },
    formatarTempo(tempoMs) {
      if (!tempoMs || tempoMs === 0 || tempoMs === null || tempoMs === undefined) {
        return 'N/A'
      }
      
      const tempo = parseFloat(tempoMs)
      
      if (tempo < 1000) {
        return Math.round(tempo) + 'ms'
      } else if (tempo < 60000) {
        return (tempo / 1000).toFixed(1) + 's'
      } else {
        return (tempo / 60000).toFixed(1) + 'min'
      }
    },
    formatarPeriodo() {
      if (!this.filtros.startDate || !this.filtros.endDate) return 'N/A'
      
      const inicio = new Date(this.filtros.startDate)
      const fim = new Date(this.filtros.endDate)
      
      return `${inicio.toLocaleDateString('pt-BR')} - ${fim.toLocaleDateString('pt-BR')}`
    },
    nomePipeline(id) {
      if (!id) return 'N/A'
      const p = this.pipelines.find(p => p.id === id)
      return p ? p.value : id
    },
    getFiltrosFormatados() {
      // Cria uma cópia dos filtros
      const filtrosFormatados = { ...this.filtros }
      
      // Se houver data inicial, adiciona o horário 00:00:00
      if (filtrosFormatados.startDate) {
        filtrosFormatados.startDate = filtrosFormatados.startDate + ' 00:00:00'
      }
      
      // Se houver data final, adiciona o horário 23:59:59 para incluir todo o dia
      if (filtrosFormatados.endDate) {
        filtrosFormatados.endDate = filtrosFormatados.endDate + ' 23:59:59'
      }
      
      return filtrosFormatados
    },
  },
}
</script>

<style scoped>
.metric-card {
  transition: all 0.3s ease;
  border: none;
  box-shadow: 0 0.15rem 1.75rem 0 rgba(58, 59, 69, 0.15);
}

.metric-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 0.25rem 2rem 0 rgba(58, 59, 69, 0.25);
}

.border-left-primary {
  border-left: 0.25rem solid #4e73df !important;
}

.border-left-success {
  border-left: 0.25rem solid #1cc88a !important;
}

.border-left-danger {
  border-left: 0.25rem solid #e74a3b !important;
}

.border-left-warning {
  border-left: 0.25rem solid #f6c23e !important;
}

.border-left-info {
  border-left: 0.25rem solid #36b9cc !important;
}

.border-left-secondary {
  border-left: 0.25rem solid #858796 !important;
}

.text-primary {
  color: #4e73df !important;
}

.text-success {
  color: #1cc88a !important;
}

.text-danger {
  color: #e74a3b !important;
}

.text-warning {
  color: #f6c23e !important;
}

.text-info {
  color: #36b9cc !important;
}

.text-secondary {
  color: #858796 !important;
}

.text-gray-800 {
  color: #5a5c69 !important;
}

/* Correção para modo noturno */
.eloca-theme-dark .text-gray-800 {
  color: #ffffff !important;
}

/* Apenas os contadores (números) devem ficar brancos, não os títulos coloridos */
.eloca-theme-dark .metric-card .h5.text-gray-800,
.eloca-theme-dark .metric-card .h6.text-gray-800 {
  color: #ffffff !important;
}

.eloca-theme-dark .card-header h5,
.eloca-theme-dark .card-header .mb-0 {
  color: #ffffff !important;
}

/* Títulos dos cards dos gráficos */
.eloca-theme-dark .card-header h5.mb-0,
.eloca-theme-dark .card .card-header h5 {
  color: #ffffff !important;
}

.eloca-theme-dark .table th,
.eloca-theme-dark .table td {
  color: #ffffff !important;
}

.eloca-theme-dark .table-striped tbody tr:nth-of-type(odd) td {
  background-color: rgba(255, 255, 255, 0.05) !important;
}

.eloca-theme-dark .pagination .page-link {
  color: #ffffff !important;
  background-color: #343a40 !important;
  border-color: #495057 !important;
}

.eloca-theme-dark .pagination .page-item.active .page-link {
  background-color: #007bff !important;
  border-color: #007bff !important;
}

.eloca-theme-dark .pagination .page-item.disabled .page-link {
  color: #6c757d !important;
  background-color: #343a40 !important;
  border-color: #495057 !important;
}

/* Correção para textos dos gráficos */
.eloca-theme-dark .simple-chart text,
.eloca-theme-dark .chartjs-render-monitor text {
  fill: #ffffff !important;
}

.eloca-theme-dark .simple-chart .chartjs-render-monitor text {
  fill: #ffffff !important;
}

.text-xs {
  font-size: 0.7rem;
}

.h5 {
  font-size: 1.25rem;
}

.h6 {
  font-size: 1rem;
}

.font-weight-bold {
  font-weight: 700 !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.no-gutters {
  margin-right: 0;
  margin-left: 0;
}

.no-gutters > .col,
.no-gutters > [class*="col-"] {
  padding-right: 0;
  padding-left: 0;
}

/* Responsividade */
@media (max-width: 768px) {
  .metric-card .h5 {
    font-size: 1rem;
  }
  
  .metric-card .h6 {
    font-size: 0.9rem;
  }
  
  .metric-card .text-xs {
    font-size: 0.65rem;
  }
}
</style>
